//E_UNIQUE

export default {
  errores: [],

  showErrors: () => {
    return this.errores
  },

  add: (err) => {
    if (this.errores) {
      this.errores.push(err)
    } else {
      this.errores = [err]
    }
  }

}



// WEBPACK FOOTER //
// ./src/services/errorService.js